import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  const navLinks = [
    { label: t('nav.home'), path: '/' },
    { label: t('nav.portfolio'), path: '/portfolio' },
    { label: t('nav.services'), path: '/services' },
    { label: t('nav.blog'), path: '/blog' },
    { label: t('nav.about'), path: '/about-me' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-sticky">
      <div className="header-container">
        <div className="header-brand">
          <Link to="/" className="header-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_ef7f9068-c57a-47e6-a371-0c0ce29395f2/artifacts/1i1z9m57_1709051552458.png" 
              alt="LPF Data Analytics" 
              className="logo-image"
            />
          </Link>
          <span className="header-slogan">Dashboards e Planilhas Personalizadas</span>
        </div>

        <nav className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'nav-link-active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://wa.me/5588996527079"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary-header"
            onClick={() => setIsMenuOpen(false)}
          >
            {t('nav.getStarted')}
          </a>
        </nav>

        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
